<template>
  <div data-testid="cart_product">
    <BasketCardDefault
      v-if="!confirmDeleteOpen"
      key="default"
      v-bind="$props"
      :basket-item="basketItem"
      :product="product"
      :variant="variant"
      :quantity="quantity"
      :available-quantity="availableQuantity"
      :custom-data="customData"
      :image-hash="imageHash"
      @click:delete="onPressDelete"
      @click:change-quantity="
        (addBasketData: AddBasketData) =>
          $emit('click:change-quantity', addBasketData)
      "
      @subscription:change="
        (subscription: SubscriptionChangeData) =>
          $emit('subscription:change', {
            subscription,
            product,
            variant,
            basketItem,
          })
      "
      @subscription:stop="
        (subscription: SubscriptionChangeData) =>
          $emit('subscription:stop', {
            subscription,
            product,
            variant,
            basketItem,
          })
      "
    />
    <BasketCardConfirmDelete
      v-else
      key="confirmDelete"
      :loading="loading"
      @click:confirm="onConfirmDelete"
      @click:cancel="onCancelDelete"
    />
  </div>
</template>
<script setup lang="ts">
import type { Product, Variant, Price } from '@scayle/storefront-nuxt'
import type { AddBasketData } from '~/components/basket/card/BasketCardDefault.vue'

defineProps({
  basketItem: {
    type: Object as PropType<FimBasketItem>,
    required: true,
  },
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  variant: {
    type: Object as PropType<Variant>,
    required: true,
  },
  name: {
    type: String as PropType<string>,
    required: true,
  },
  title: {
    type: String as PropType<string>,
    required: true,
  },
  unitPrice: {
    type: Object as PropType<Price>,
    required: true,
    default: () => {},
  },
  imageHash: {
    type: String as PropType<string>,
    default: undefined,
  },
  quantity: {
    type: Number as PropType<number>,
    default: 1,
  },
  availableQuantity: {
    type: Number as PropType<number>,
    default: undefined,
  },
  displayData: {
    type: Object as PropType<object>,
    default: undefined,
  },
  customData: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },
})

const loading = ref(false)
const confirmDeleteOpen = ref(false)
const emit = defineEmits([
  'click:change-quantity',
  'click:remove-from-basket',
  'subscription:change',
  'subscription:stop',
])

const onPressDelete = () => {
  confirmDeleteOpen.value = true
}

const onCancelDelete = () => {
  confirmDeleteOpen.value = false
}

const onConfirmDelete = () => {
  loading.value = true
  emit('click:remove-from-basket')
}
</script>
